export default function PHP_ob_clean() {
  return (
    <div>
      <h1>PHP_ob_clean</h1>
    </div>
  );
}
